import { UserInterface } from './types';
import { defaultSubaccountQueryParams } from '../../../definitions/constants';

const LOG_PREFIX = '[UserProvider]';

const defaultContext: UserInterface = {
  account: undefined,
  accounts: undefined,
  appliedSubaccountFilters: defaultSubaccountQueryParams,
  csrf: undefined,
  doesPageRequireLogin: true,
  hasAccountSwitcherError: false,
  hasCsrfError: false,
  isLoggedIn: false,
  isLoading: true,
  isLoadingAccountSwitcher: false,
  isLoadingSubaccounts: false,
  isOnSubaccount: false,
  subaccountsMetadata: undefined,
  setAppliedSubaccountFilters: () => {},
  updateCurrentAccountSid: () => Promise.resolve(false),
  user: undefined,
};

const constants = {
  defaultContext,
  LOG_PREFIX,
};

export default constants;
